/** Euklidische Pixel-Distanz. */
export function pixelDistance(a, b) {
    return Math.hypot(b.x - a.x, b.y - a.y);
}
/**
 * Meter pro Pixel aus einer Referenzstrecke.
 * @throws RangeError bei 0-Pixel-Strecke oder realLengthM ≤ 0.
 */
export function metersPerPixel(aPx, bPx, realLengthM) {
    const d = pixelDistance(aPx, bPx);
    if (d <= 0)
        throw new RangeError("Referenzstrecke hat 0 Pixel Länge");
    if (!(realLengthM > 0))
        throw new RangeError("realLengthM muss > 0 sein");
    return realLengthM / d;
}
/** Pixel-Länge → Meter (gegeben Meter pro Pixel). */
export function pixelLengthToMeters(lengthPx, mPerPx) {
    return lengthPx * mPerPx;
}
/**
 * Validiert eine Kalibrier-Eingabe, bevor sie übernommen wird (isCalibrated-Gate).
 * Liefert kein throw, sondern ein Prüfresultat — geeignet fürs UI.
 * @param opts.minPixelDistance Mindest-Referenzlänge in Pixeln (Default 20).
 */
export function validateCalibration(aPx, bPx, realLengthM, opts) {
    const minPx = opts?.minPixelDistance ?? 20;
    const d = pixelDistance(aPx, bPx);
    if (!(realLengthM > 0))
        return { ok: false, reason: "realLengthM muss > 0 sein" };
    if (d <= 0)
        return { ok: false, reason: "Referenzstrecke hat 0 Pixel Länge" };
    if (d < minPx) {
        return {
            ok: false,
            reason: `Referenzstrecke zu kurz (${d.toFixed(1)} px < ${minPx} px) — Maßstab wird ungenau`,
        };
    }
    return { ok: true, metersPerPixel: realLengthM / d };
}
//# sourceMappingURL=scale.js.map